import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';

import { actions as createPostActions } from '../../../redux/communities/createPost';
import { actions as reqJoinCommunity } from '../../../redux/communities/reqJoinCommunity';
import { actions as joinPopupActions } from '../../../redux/communities/joinPopup';
import { selectCreateCommunityPost } from '../../../redux/communities/selectors/selectors';
import { isLoggedInSelector } from '../../../redux/auth/selectors';
import styles from './index.styl';

const mapDispatchToProps = {
  createPost: createPostActions.send,
  reqJoinCommunity: reqJoinCommunity.send,
  openJoinPopup: joinPopupActions.show,
};

const mapStateToProps = state => ({
  createPostRequest: selectCreateCommunityPost(state),
  isLoggedIn: isLoggedInSelector(state),
});

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Community/NewPost/enhance.js